<!--
 * @Descripttion: 验货表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-22 10:36:43
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-02 14:02:44
 -->
<template>
  <div>
    <div class="cell_table">
      <div class="cell_cont">
        <div style="height: calc(100% - 45px);overflow: auto;">
          <el-table :data="inspectionInfoList" border>
            <el-table-column type="index" label="编号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="goodsName" label="物料名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specification" label="物料规格型号" width="110"></el-table-column>
            <el-table-column show-overflow-tooltip prop="goodsCode" label="物料编码"></el-table-column>
            <el-table-column show-overflow-tooltip prop="batchNumber" label="批号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="packageNumber" label="实际出库数量" width="100" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="quantifiedNumber" label="已验货数量" width="90" ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="$btnsPermission('outbound:ck')" type="text" @click="handlePreview(scope.row)">查看UDI码</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <outboundUdiReview
      v-if="reviewVisible"
      :visible="reviewVisible"
      :dict-obj="dictObj"
      :product-info="reviewData"
      @close="reviewVisible=false"/>
  </div>
</template>
<script>
import { getInspectionInfoByOrderId } from '@/api/orderManage'
import OutboundUdiReview from "@/views/outboundManage/components/previewUdi/outboundUdiReview.vue";

export default {
  name: 'CheckList',
  components: { OutboundUdiReview },
  props: {
    dictObj:{
      type:Object,
      default:()=>{
        return {
          receiptDeliveryState:[]
        }
      }
    },
  },
  data() {
    return {
      inspectionInfoList: [],
      reviewVisible: false, // 预览弹框是否显示
      reviewData: {}, // 预览数据
    }
  },
  created() {
  },
  methods: {
    // 获取验货表信息
    getInspectionInfoByOrderId({orderId}) {
      this.$emit('changeParentLoading', true)
      getInspectionInfoByOrderId({ orderId, pageNum: 1, pageSize: 9999 }).then(res => {
        this.inspectionInfoList = res.rows
        // eslint-disable-next-line handle-callback-err
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
    //   处理预览UDI
    handlePreview(row) {
      this.reviewData = row
      this.reviewVisible = true
    }
  }
}
</script>
